import services from "@/utils/request";

// 查询用户权限
export function listOne(parms) {
  return services.request({
    method: "GET",
    url: "/system/menu/getRouters",
  });
}

// 获取用户角色列表
export function listRole(parms) {
  return services.request({
    method: "GET",
    url: "/purchase/getSubAccountRolesByCurrentPurchaseNo",
    params: parms,
  });
}
// 获取用户列表
export function listUser(parms) {
  return services.request({
    method: "GET",
    url: "/purchase/getSubAccountsByCurrentAccount",
    params: parms,
  });
}

// 添加子账号
export function addPurchaseSubAccount(parms) {
  return services.request({
    method: "POST",
    url: "/purchase/addPurchaseSubAccount",
    data: parms,
  });
}
// 删除子账号
export function deletePurchaseSubAccount(parms) {
  return services.request({
    method: "DELETE",
    url: `/purchase/${parms.userId}`,
    // data: parms,
  });
}
// 编辑子账号
export function editPurchaseSubAccount(parms) {
  return services.request({
    method: "POST",
    url: "/purchase/updatePurchaseSubAccount",
    data: parms,
  });
}
// 状态修改

export function updatePurchaseSubAccountStatus(parms) {
  return services.request({
    method: "POST",
    url: "/purchase/changeStatus",
    data: parms,
  });
}
// 查询子账户授权店铺列表

export function listShop(parms) {
  return services.request({
    method: "GET",
    url: "/purchase/queryShopsForSubAccountByCondition",
    params: parms,
  });
}
// 为子账户授权店铺

export function bindShop(parms) {
  return services.request({
    method: "POST",
    url: "/purchase/assignShopsToSubAccount",
    data: parms,
  });
}

// 消息推送

export function pushMessage(parms) {
  return services.request({
    method: "GET",
    url: "/resource/sse",
    params: parms,
  });
}
